"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOM = void 0;
var DOM;
(function (DOM) {
    /** Check if the element that was clicked was inside a given element */
    function clickIsInsideElement(element, event) {
        return (element && event.target === element) || element.contains(event.target);
    }
    DOM.clickIsInsideElement = clickIsInsideElement;
    function domRectToObject(domRect) {
        var top = domRect.top, right = domRect.right, bottom = domRect.bottom, left = domRect.left, width = domRect.width, height = domRect.height, x = domRect.x, y = domRect.y;
        return { top: top, right: right, bottom: bottom, left: left, width: width, height: height, x: x, y: y };
    }
    DOM.domRectToObject = domRectToObject;
})(DOM = exports.DOM || (exports.DOM = {}));
